var map = {
	"./esports-bg.webp": 1646,
	"./esports-ctg.webp": 1647,
	"./im-img.webp": 1648,
	"./im-title-cn.webp": 1649,
	"./im-title-en.webp": 1650,
	"./object-1.webp": 1651,
	"./object-2.webp": 1652,
	"./object-3.webp": 1653,
	"./object-4.webp": 1654,
	"./tfg-img.webp": 1655,
	"./tfg-title-cn.webp": 1656,
	"./tfg-title-en.webp": 1657,
	"./title-cn.webp": 1658,
	"./title-en.webp": 1659
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1645;